export default __webpack_public_path__ + "static/media/finak 1.4f26e479.png";